import Controller, { OnClick, OnClose } from '@philips-internal/oswald-ui-core/lib/client';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import BaseController from '../BaseController';
@Controller({ component: 'root-modal', fragment: 'forget-password-request-success' })
class ForgetPasswordRequestSuccessController extends BaseController {

  @OnClick({ target: ['ok-button'] })
  onButtonClose(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  @OnClose({ target: ['root-modal'] })
  onRootModalClose(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}

export default ForgetPasswordRequestSuccessController;
